// React Components
import React from "react";

// Material UI Components
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';


// Function to insert our Site Collection selector (textfield).
// Later enhance to auto-complete on site name.
export default function SiteCollectionSelector(props){

    const { tenantId, selectedSite, setSelectedSite, selectedSiteValue, errorSelectedSite } = props;

    return(
        
        <Grid item xs={12}>
            {/* User input field control. */}
            <Box sx={{ display: 'grid', gridTemplateColumns: { xs: 'minmax(0, 1fr)', sm: '140px minmax(0, 600px)' }, gap: { xs: 1, sm: 0 }, width: '100%' }}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <b>Site or Location:</b>
                </Box>
                <Box sx={{ minWidth: 0 }}>
                    <TextField                        
                        required
                        name="Site Collection Text Field"
                        id="siteTextfield"
                        placeholder="Enter path to site, file, or folder (ex. https://mydomain.sharepoint.com/sites/hr)."
                        variant="outlined"
                        size="small"
                        fullWidth
                        inputProps={{ maxLength: 300 }}
                        InputLabelProps={{ shrink: true }}
                        onChange={event => setSelectedSite(event.target.value)}
                        inputRef={selectedSiteValue}
                        value={selectedSite}
                        error={errorSelectedSite}
                        helperText={errorSelectedSite ? 'Site Collection or location cannot be empty.' : ''}                     
                    />
                </Box>
            </Box>
        </Grid>
    );
};
